import { useEffect, useState } from "react"
import { Form, useParams } from "react-router-dom";
import { getStockById, inventoryStock } from "../../common/services/stock.api";
import { IStockDetailTable } from "../../types/stock.types";

import "./index.scss";
import GenericTable from "../../common/components/ui/table/GenericTable";
import { HiOutlineDownload } from "react-icons/hi";
import { GenericInfoField } from "../../common/helpers/generic-info-field";
import Loading from "../../common/components/ui/loading/Loading";
import { maskCurrency } from "../../common/helpers/mask.helpers";
import { FormikProvider, useFormik } from "formik";
import InputFormik from "../../common/components/form/InputFormik";
import ButtonWithLoader from "../../common/components/ui/loading/ButtonLoading";
import { useToastContext } from "../../common/components/ui/toast/toast.context";

export function NfsDashboard() {

  const { stockId } = useParams();
  const [stock, setStock] = useState<IStockDetailTable>();
  const [reloadStock, setReloadStock] = useState({});
  const { notifyError, notifySuccess } = useToastContext();

  useEffect(() => {

    async function loadStock() {
      if (!stockId) {
        return;
      }

      const result = await getStockById(stockId);
      setStock(result.data);
    }
    loadStock();

  }, [stockId, reloadStock]);

  const formik = useFormik({
    initialValues: { quantity: 0, stockId: stockId as string },
    onSubmit: async function (values) {

      const result = await inventoryStock(values);
      setReloadStock({});
      if (!result.ok) {
        notifyError(result.message as string);
        return
      }
      notifySuccess("Estoque alterado com sucesso");
    }
  });

  const stockDetails = stock?.details || []
  const details = [...(stock?.movementproducts || []), ...stockDetails]
  return (
    <div className="relative w-full h-full overflow-y-auto bg-white text-black dark:text-black">
      <section className="w-full h-full">
        <div className="containerStockDashboard">
          {details ?
            <div className="container-stock">
              <GenericTable
                data={details}
                renders={
                  {
                    nf: (NF) => {
                      // Verifique se NF é um array, caso seja, pegue o primeiro valor válido
                      let nfUrl = Array.isArray(NF) ? NF.find(nf => nf !== "") : NF;

                      // Se nfUrl ainda estiver vazia, defina como uma string vazia
                      nfUrl = nfUrl || "";

                      return nfUrl !== "" ? (
                        <a href={`https://assets.locavibe.com.br/${nfUrl}`} target="_blank" rel="noopener noreferrer">
                          <HiOutlineDownload className="mx-auto mb-4 h-6 w-6 text-gray-400 dark:text-gray-200" />
                        </a>
                      ) : (
                        <span>-</span>
                      );
                    },
                    createdAt: (createdAt) => new Date(createdAt as Date).toLocaleDateString("pt-BR"),
                    sellPrice: (sellPrice) => maskCurrency((sellPrice as number).toFixed(2)),
                    costPrice: (sellPrice) => maskCurrency((sellPrice as number).toFixed(2)),
                    costFreight: (sellPrice) => maskCurrency((sellPrice as number).toFixed(2)),
                    costPriceWithFreight: (sellPrice) => maskCurrency((sellPrice as number).toFixed(2))
                  }
                }
                headers={{
                  createdAt: "Data",
                  costPrice: "Preço de custo",
                  costFreight: "Preço de Entrega",
                  costPriceWithFreight: "Preço de custo + entrega",
                  sellPrice: "Preço de Venda",
                  quantity: "Quantidade",
                  supplierName: "Fornecedor",
                  nf: "nf"
                }}
              >
              </GenericTable>
              <div className="containerInventory">
                <div className="containerInventory-div">
                  <h2>Inventário de Estoque</h2>
                  <FormikProvider value={formik}>
                    <Form>
                      <InputFormik name="quantity" type="number"></InputFormik>
                      <ButtonWithLoader onClick={formik.handleSubmit}>Alterar Quantidade</ButtonWithLoader>
                    </Form>
                  </FormikProvider>
                </div>
              </div>
            </div>
            : <Loading></Loading>}
          <div className="container-info">
            <div className="cotainer-info-header">
              <h1 className="text-2xl font-semibold mt-4 ml-4">Informações do Produto:</h1>
            </div>
            <div className="cotainer-info-body">
              <GenericInfoField id={1} value={stock?.product.code} label={"Código"} spanSize={3}></GenericInfoField>
              <GenericInfoField id={1} value={stock?.product.name} label={"Descrição"} spanSize={3}></GenericInfoField>
              <GenericInfoField id={1} value={stock?.details.reduce((total, detail) => detail.quantity + total, 0)} label={"Quantidade Total"} spanSize={3}></GenericInfoField>
              <GenericInfoField id={1} value={stock?.minimumQuantity} label={"Quantidade Mínima"} spanSize={3}></GenericInfoField>
              <GenericInfoField id={1} value={stock?.product.maximumApplication} label={"Aplicação Máxima"} spanSize={3}></GenericInfoField>
              <GenericInfoField id={1} value={stock?.product.category} label={"Categoria"} spanSize={3}></GenericInfoField>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
